import { Component, input, output } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect, MatSelectChange } from '@angular/material/select';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppTooltipComponent } from '../app-tooltip/app-tooltip.component';
import { DialogFormErrorComponent } from '../dialog-form-error/dialog-form-error.component';

@Component({
  selector: 'app-dialog-select',
  imports: [
    MatFormField,
    MatSelect,
    ReactiveFormsModule,
    MatLabel,
    TranslocoPipe,
    MatOption,
    AppTooltipComponent,
    DialogFormErrorComponent
  ],
  templateUrl: './dialog-select.component.html'
})
export class DialogSelectComponent {
  ctrl = input<AbstractControl>();

  label = input<string>();

  hint = input<string>();

  options = input<{ value: string; label: string; disabled?: boolean }[]>();

  selectionChange = output<MatSelectChange>();

  getControl(): FormControl {
    return (this.ctrl() as FormControl);
  }

  handleSelectionChange(event: MatSelectChange): void {
    this.selectionChange.emit(event);
  }
}
